import { appModule } from "@/store/modules/app";

export const PESAN_GAGAL_JARINGAN =
  "Koneksi ke server bermasalah atau server terlalu lama merespons. " +
  "Isian Anda masih ada di layar dan BELUM tersimpan — periksa koneksi lalu " +
  "tekan tombol Simpan lagi. Jangan memuat ulang atau menutup halaman.";

export const PESAN_GAGAL_MUAT =
  "Data gagal dimuat karena koneksi ke server bermasalah atau server terlalu " +
  "lama merespons. Periksa koneksi lalu coba lagi.";

export function pesanGagalJaringan(method?: string): string {
  return method && method.toLowerCase() === "get"
    ? PESAN_GAGAL_MUAT
    : PESAN_GAGAL_JARINGAN;
}

export function isGagalJaringan(err: any): boolean {
  return !!err && !err.response;
}

export function tampilkanGagalJaringan(pesan: string = PESAN_GAGAL_JARINGAN): void {
  appModule.sendErrorAlert(pesan);
}

export function tanganiGagalJaringan(err: any, pesan?: string): boolean {
  if (!isGagalJaringan(err)) return false;
  tampilkanGagalJaringan(pesan);
  return true;
}
